// CFS wholesale bread page (sections/cfs-wholesale.liquid): the order builder in the enquiry form.
// − / + steppers, a running total, and on send: only breads with a quantity are emailed, each as its
// title over "SKU: … / Quantity: …", so the enquiry reads like an order. At least one bread is required.
// The form posts normally: Shopify's bot protection answers background (fetch) posts with a
// "Verifying your connection" page (owner test, 10 Oct 2026). After the reload Liquid shows the
// thank-you panel in place of the form; the order they built is carried over in sessionStorage.
const form = document.getElementById('CfsWholesaleForm');
const order = form?.querySelector('[data-cfs-ws-order]');
const STORE_KEY = 'cfs-ws-enquiry';

const storage = {
  get() {
    try {
      return JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
    } catch {
      return null;
    }
  },
  set(value) {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify(value));
    } catch {}
  },
  clear() {
    try {
      sessionStorage.removeItem(STORE_KEY);
    } catch {}
  },
};

// After sending: fill the thank-you panel with the order they built
const thanks = form?.querySelector('[data-cfs-ws-thanks]');
if (thanks) {
  const sent = storage.get();
  if (sent?.lines?.length) {
    const list = thanks.querySelector('[data-cfs-ws-thanks-list]');
    for (const line of sent.lines) {
      const li = document.createElement('li');
      li.textContent = line;
      list.append(li);
    }
    if (sent.often) thanks.querySelector('[data-cfs-ws-thanks-often]').textContent = `How often: ${sent.often}`;
    thanks.querySelector('[data-cfs-ws-thanks-order]').hidden = false;
  }
  storage.clear();
  thanks.focus({ preventScroll: true });
}

if (order) {
  const inputs = [...order.querySelectorAll('input[type="number"]')];
  const total = order.querySelector('[data-cfs-ws-total]');
  const error = order.querySelector('[data-cfs-ws-error]');

  const qty = (input) => Math.max(0, Math.min(999, parseInt(input.value, 10) || 0));

  const update = () => {
    let breads = 0;
    let items = 0;
    for (const input of inputs) {
      const n = qty(input);
      input.closest('.cfs-ws-order__row').classList.toggle('is-chosen', n > 0);
      if (n > 0) {
        breads += 1;
        items += n;
      }
    }
    total.textContent = items
      ? `${items} ${items === 1 ? 'item' : 'items'} across ${breads} ${breads === 1 ? 'bread' : 'breads'}`
      : 'Nothing chosen yet';
    if (items) error.hidden = true;
    return items;
  };

  order.addEventListener('click', (event) => {
    const button = event.target.closest('[data-step]');
    if (!button) return;
    const input = button.parentElement.querySelector('input');
    input.value = String(Math.max(0, Math.min(999, qty(input) + Number(button.dataset.step))));
    update();
  });

  order.addEventListener('input', update);

  // Select the whole number on focus so typing replaces the 0
  order.addEventListener('focusin', (event) => {
    if (event.target.matches('input[type="number"]')) event.target.select();
  });

  form.addEventListener('submit', (event) => {
    if (!update()) {
      event.preventDefault();
      error.hidden = false;
      order.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    const chosen = inputs.filter((input) => qty(input) > 0);
    const lines = chosen.map((input) => `${qty(input)} × ${input.dataset.name}`);
    storage.set({ lines, often: form.querySelector('input[name="contact[How often]"]:checked')?.value });
    // The email lists each field as its name (bold) over its value: send one field per chosen bread,
    // titled with the bread, holding its SKU and quantity. The quantity boxes themselves aren't sent.
    order.querySelectorAll('[data-cfs-ws-line]').forEach((line) => line.remove());
    for (const input of chosen) {
      const line = document.createElement('input');
      line.type = 'hidden';
      line.name = `contact[${input.dataset.name}]`;
      line.value = `SKU: ${input.dataset.sku || 'n/a'}\nQuantity: ${qty(input)}`;
      line.dataset.cfsWsLine = '';
      input.closest('.cfs-ws-order__row').append(line);
    }
    for (const input of inputs) input.disabled = true;
    const button = form.querySelector('[type="submit"]');
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Sending…';
  });

  // Back/forward cache: re-enable after returning to the page
  const submitButton = form.querySelector('[type="submit"]');
  const submitLabel = submitButton.textContent;
  window.addEventListener('pageshow', () => {
    for (const input of inputs) input.disabled = false;
    order.querySelectorAll('[data-cfs-ws-line]').forEach((line) => line.remove());
    submitButton.textContent = submitLabel;
    submitButton.removeAttribute('aria-busy');
    update();
  });

  update();
}
